import { NgModule } from '@angular/core';
//import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule} from '@angular/material/icon';
import { MatListModule} from '@angular/material/list';
import { MatCardModule} from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SplashscreenComponent } from './components/splashscreen/splashscreen.component';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { NgOtpInputModule } from 'ng-otp-input';
import { AuthPageModule } from './pages/auth/auth.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatOptionModule } from '@angular/material/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ExcelExportService } from '@syncfusion/ej2-angular-grids';
import { MatSelectModule } from '@angular/material/select';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
  declarations: [
    AppComponent,
                 HeaderComponent,
                 FooterComponent,
                 SplashscreenComponent,
                 ],
  imports: [
    IonicModule.forRoot(),
    NgOtpInputModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatDialogModule,
    FlexLayoutModule,
    AuthPageModule,
    MatSnackBarModule,
    DialogModule,
    MatTableModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    ScrollingModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    OverlayModule,
  NgxExtendedPdfViewerModule
  ],
  providers: [{ provide: RouteReuseStrategy,useClass: IonicRouteStrategy},{provide: LocationStrategy, useClass: HashLocationStrategy},DatePipe,ExcelExportService],
  bootstrap: [AppComponent],
})
export class AppModule {}
